/**
 * Workspace page/tab correlation IDs recovered from the shipped tenant bundle.
 *
 * Emitted module 693583 in Compass asset
 * e930f7c2...3e1ee always replaces `workspace_page_session_id` with a UUID v4
 * and creates `workspace_tab_session_id` only when the tab has none. Module
 * 994310 uses `crypto.randomUUID()` with a getRandomValues UUID-v4 fallback.
 */

export const WORKSPACE_PAGE_SESSION_ID = "workspace_page_session_id";
export const WORKSPACE_TAB_SESSION_ID = "workspace_tab_session_id";

export interface SessionStorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export interface WorkspaceSessionIds {
  readonly pageSessionId: string;
  readonly tabSessionId: string;
}

export function initializeWorkspaceSession(
  storage: SessionStorageLike,
  randomUuid: () => string = () => crypto.randomUUID(),
): WorkspaceSessionIds {
  const pageSessionId = randomUuid();
  storage.setItem(WORKSPACE_PAGE_SESSION_ID, pageSessionId);

  let tabSessionId = storage.getItem(WORKSPACE_TAB_SESSION_ID);
  if (tabSessionId === null) {
    tabSessionId = randomUuid();
    storage.setItem(WORKSPACE_TAB_SESSION_ID, tabSessionId);
  }

  return Object.freeze({ pageSessionId, tabSessionId });
}
